import { connect } from 'react-redux';
import { getSettings } from '../../selectors/settings';
import { getConvo } from '../../selectors/conversation';
import { ctaClicked, smsCtaClicked } from '../../actions';
import CtaFactory from './CtaFactory';
import { RootState } from '../../typedefs/store';

const mapStateToProps = (state: RootState) => {
    const { active, starting } = getConvo(state);
    return {
        settings: getSettings(state),
    };
};

const mapDispatchToProps = { ctaClicked, smsCtaClicked };

export default connect(mapStateToProps, mapDispatchToProps)(CtaFactory);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Cta/CtaContainer.tsx